<template>
    <ValidationObserver ref="todoform">
        <div v-if="todo_data">
            <div class="row">
                <div class="col-8">
                    <ValidationProvider vid="subject" name="Namn" rules="required" v-slot="{ errors }">
                        <div class="form-group">
                            <label>Namn <span class="text-danger">*</span></label>
                            <v-select
                                v-model="todo_data.subject"
                                :options="select_todo_subject"
                                :reduce="opt => opt.label"
                                placeholder="Välj/Skriv..."
                                taggable
                            ></v-select>
                            <span class="validation-invalid-label">{{ errors[0] }}</span>
                        </div>
                    </ValidationProvider>
                </div>
                <div class="col-4">
                    <ValidationProvider vid="company_id" name="Företag" rules="" v-slot="{ errors }">
                        <div class="form-group">
                            <label>Företag</label>
                            <div class="input-group">
                                <v-select
                                    v-model="todo_data.company_id"
                                    :options="Object.values(companies)"
                                    placeholder="Välj företag"
                                    :reduce="opt => opt.id"
                                    label="text"
                                ></v-select>
                                <div class="input-group-append">
                                    <router-link :to="{ name:'crm.company', params: { id: todo_data.company_id }, query: { from: current_url } }" class="btn btn-light btn-icon" target="_blank"><i class="icon-office"></i></router-link>
                                </div>
                            </div>
                            <span class="validation-invalid-label">{{ errors[0] }}</span>
                        </div>
                    </ValidationProvider>
                </div>
            </div>
            <div class="row">
                <div class="col-6">
                    <ValidationProvider vid="start_ts" name="Datum" rules="required" v-slot="{ errors }">
                        <div class="form-group">
                            <label>Datum <span class="text-danger">*</span></label>
                            <v-date-picker v-model="todo_data.start_ts" mode="dateTime" :is24hr="true" :model-config="{ type: 'string', mask: 'YYYY-MM-DD HH:mm' }" :masks="{ input: 'YYYY-MM-DD HH:mm' }">
                                <template v-slot="{ togglePopover }">
                                    <input class="form-control" :value="todo_data.start_ts" @focus="togglePopover()">
                                </template>
                            </v-date-picker>
                            <span class="validation-invalid-label">{{ errors[0] }}</span>
                        </div>
                    </ValidationProvider>
                </div>
                <div class="col-2">
                </div>
                <div class="col-4">
                    <div class="form-group">
                        <label>Antal gåvor</label>
                        <input type="text" class="form-control" disabled :value="(companies[todo_data.company_id] ? companies[todo_data.company_id].gifts : '')">
                    </div>
                </div>
<!--                <div class="col-6">-->
<!--                    <ValidationProvider vid="end_ts" name="Måste vara klart" rules="required" v-slot="{ errors }">-->
<!--                        <div class="form-group">-->
<!--                            <label>Måste vara klart <span class="text-danger">*</span></label>-->
<!--                            <limitless-date-range-picker v-model="todo_data.end_ts" :settings="datepickersettings" :has_error="(!!errors[0])"></limitless-date-range-picker>-->
<!--                            <span class="validation-invalid-label">{{ errors[0] }}</span>-->
<!--                        </div>-->
<!--                    </ValidationProvider>-->
<!--                </div>-->
            </div>
            <ValidationProvider vid="text" name="Beskrivning" rules="" v-slot="{ errors }">
                <div class="form-group">
                    <label>Beskrivning</label>
                    <textarea class="form-control" v-model="todo_data.text" v-bind:class="{ 'border-danger':errors[0] }"></textarea>
                    <span class="validation-invalid-label">{{ errors[0] }}</span>
                </div>
            </ValidationProvider>
            <div class="row">
                <div class="col-8">
                    <ValidationProvider vid="user_id" name="Medarbetare" rules="required" v-slot="{ errors }">
                        <div class="form-group">
                            <label>Medarbetare <span class="text-danger">*</span></label>
                            <v-select
                                v-model="todo_data.user_id"
                                :options="select_users"
                                placeholder="Välj medarbetare"
                                :reduce="opt => opt.id"
                                label="name"
                            ></v-select>
                            <span class="validation-invalid-label">{{ errors[0] }}</span>
                        </div>
                    </ValidationProvider>
                </div>
                <div class="col-4">
                    <ValidationProvider vid="priority" name="Prioritet" rules="required" v-slot="{ errors }">
                        <div class="form-group">
                            <label>Prioritet <span class="text-danger">*</span></label>
                            <v-select
                                v-model="todo_data.priority"
                                :options="select_priority"
                                placeholder="Välj prioritet"
                                :reduce="opt => opt.id"
                                label="text"
                            ></v-select>
                            <span class="validation-invalid-label">{{ errors[0] }}</span>
                        </div>
                    </ValidationProvider>
                </div>
            </div>
            <div v-if="todo_data.id>0" class="text-muted">Senast uppdaterad {{ formatDateTime(todo_data.updated_at) }}<span v-if="todo_data.updated_by"> av {{ todo_data.updated_by.name }}</span></div>
        </div>
    </ValidationObserver>
</template>

<script>
import vSelect from 'vue-select';
import VDatePicker from 'v-calendar/lib/components/date-picker.umd';
import { formatDateTime } from '@services/Helpers';

export default {
    name: 'TodoForm',
    components: {
        vSelect,
        VDatePicker,
    },
    props: {
        busy: {
            type: Boolean,
            default: false,
        },
        value: {
            type: Object,
            default() {
                return {};
            },
        },
        users: {
            type: Array,
            default() {
                return [];
            },
        },
        companies: {
            type: Object,
            default() {
                return {};
            },
        },
        strings: {
            type: Object,
            default() {
                return {};
            },
        },
    },
    watch: {
        value(data) {
            this.todo_data = data;
        },
        todo_data: {
            deep: true,
            handler(val) {
                this.$emit('change', val);
            },
        },
    },
    data: () => ({
        todo_data: null,
    }),
    mounted() {
        this.todo_data = this.value;
    },
    methods: {
        formatDateTime,
        async validate() {
            return this.$refs.todoform.validate();
        },
        async setErrors(errors) {
            return this.$refs.todoform.setErrors(errors);
        },
    },
    computed: {
        select_todo_subject() {
            const arr = [];
            if (this.strings[2]) {
                this.strings[2].forEach((string) => {
                    if (!arr.find((s) => s.label === string.string)) {
                        arr.push({ label: string.string });
                    }
                });
            }
            if (this.todo_data) {
                if (!arr.find((s) => s.label === this.todo_data.subject)) {
                    arr.push({ label: this.todo_data.subject });
                }
            }
            return arr;
        },
        select_priority() {
            const arr = [];
            arr.push({ id: 1, text: 'Hög' });
            arr.push({ id: 2, text: 'Medel' });
            arr.push({ id: 3, text: 'Låg' });
            return arr;
        },
        select_users() {
            const arr = [];
            if (this.todo_data.company_id && this.companies[this.todo_data.company_id]) {
                Object.values(this.companies[this.todo_data.company_id].sellers).forEach((seller) => {
                    arr.push({ id: seller.id, name: '☆ ' + seller.name });
                });
            }
            Object.values(this.users).forEach((seller) => {
                if (seller && seller.permissions && seller.permissions.includes('red_sales_crm_show_others')) {
                    if (!arr.find((s) => s.id === seller.id)) {
                        arr.push({ id: seller.id, name: seller.name });
                    }
                }
            });
            return arr;
        },
        current_url() {
            const { id } = this.todo_data; // eslint-disable-line no-unused-vars
            const currentState = history.state; // eslint-disable-line no-restricted-globals
            const urlParams = Object.keys(currentState).map((key) => `${key}=${encodeURIComponent(currentState[key])}`).join('&');
            return `${this.$route.fullPath}?${urlParams}`;
        },
    },
};
</script>

<style scoped>

</style>
